import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Tooltip } from '..';

var mapIndexed = R.addIndex(R.map);
var ButtonCarousel = function ButtonCarousel(_ref) {
  var selectionModes = _ref.selectionModes,
      selectionMode = _ref.selectionMode,
      setSelectionMode = _ref.setSelectionMode,
      classes = _ref.classes;

  return React.createElement(
    Box,
    {
      sx: {
        overflowX: 'auto',
        overflowY: 'hidden',
        whiteSpace: 'nowrap',
        display: 'block', // allow horizontal scrolling
        width: '100%',
        maxWidth: '100%',
        '&::-webkit-scrollbar': { display: 'none' }, // optional: hide scrollbar
        scrollbarWidth: 'none'
      }
    },
    mapIndexed(function (_ref2) {
      var value = _ref2.value,
          label = _ref2.label,
          img = _ref2.img;
      return React.createElement(
        Tooltip,
        {
          key: value,
          classes: { tooltip: classes.tooltip },
          title: React.createElement('img', { style: { width: '72px', height: '90px' }, src: img, alt: value }),
          tabIndex: -1
        },
        React.createElement(
          Button,
          {
            className: classes.selectButton,
            selected: value === selectionMode,
            onClick: function onClick() {
              setSelectionMode(value);
            },
            'aria-pressed': value === selectionMode,
            'aria-label': label,
            tabIndex: 0,
            sx: {
              flex: '0 0 auto', // Prevents buttons from shrinking
              scrollSnapAlign: 'center',
              minWidth: 120, // Minimum width for buttons
              whiteSpace: 'nowrap'
            }
          },
          React.createElement(
            Paper,
            { elevation: 0, className: classes.selectModeItem, key: value },
            React.createElement(
              Typography,
              null,
              label
            ),
            !R.isNil(img) && R.is(String, img) && React.createElement('img', { src: img, alt: value })
          )
        )
      );
    }, selectionModes)
  );
};

export default ButtonCarousel;

ButtonCarousel.propTypes = process.env.NODE_ENV !== "production" ? {
  selectionModes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    img: PropTypes.string
  })).isRequired,
  selectionMode: PropTypes.string.isRequired,
  setSelectionMode: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
} : {};